<div class="content-area">
  <div class="title-block">
    <h1>{{ pageTitle }}</h1>

    <div class="title-block__right">
      <a class="back-btn" href="javascript:void(0);" [routerLink]="['/admin/settings/application']"><i class="back-new"></i> Back</a>
    </div>
  </div>

  <div class="form-content-outer">
    <div class="form-outer enableToAddHoliday-form-hide">
      <form [formGroup]="holidayForm" class="form" (ngSubmit)="onSubmit()">
        <div class="col">
          <div class="form__group">
            <label class="form__label">Year</label>
            <p-select
              class="form__dropdown select-box"
              formControlName="appHolidayYear"
              [options]="years"
              placeholder="Select Year"
              optionLabel="label"
              optionValue="value"
              (onChange)="onYearChange($event.value)"
            >
            </p-select>
            <div *ngIf="holidayForm.get('appHolidayYear')?.invalid && holidayForm.get('appHolidayYear')?.touched" class="invalid-feedback">Year is Required.</div>
          </div>
          <div class="form__group">
            <label class="form__label">Holiday Name</label>
            <input type="text" class="form__control" pInputText formControlName="appHolidayName" />
            <div *ngIf="holidayForm.get('appHolidayName')?.invalid && holidayForm.get('appHolidayName')?.touched" class="invalid-feedback">Display Name is Required.</div>
          </div>
        </div>
        <div class="col">
          <div class="form__group">
            <label class="form__label">From Date</label>
            <p-datepicker
              class="form__calendars datepicker"
              [minDate]="minSelectableDate"
              [maxDate]="maxSelectableDate"
              [showIcon]="true"
              formControlName="appHolidayStartDateTime"
              placeholder="Holiday Start Date"
              dateFormat="mm/dd/yy"
            >
            </p-datepicker>
            <div *ngIf="holidayForm.get('appHolidayStartDateTime')?.invalid && holidayForm.get('appHolidayStartDateTime')?.touched" class="invalid-feedback">
              Start Date is Required.
            </div>
          </div>
          <div class="form__group">
            <label class="form__label">To Date</label>
            <p-datepicker
              class="form__calendars datepicker"
              [minDate]="minSelectableDate"
              [maxDate]="maxSelectableDate"
              [showIcon]="true"
              formControlName="appHolidayEndDateTime"
              placeholder="Holiday End Date"
              appendTo="body"
            >
            </p-datepicker>
            <div *ngIf="holidayForm.get('appHolidayEndDateTime')?.invalid && holidayForm.get('appHolidayEndDateTime')?.touched" class="invalid-feedback">
              End Date is Required
            </div>
            <div *ngIf="holidayForm.hasError('dateRange')" class="invalid-feedback">End Date should be larger than Start Date.</div>
          </div>
        </div>

        <div class="col">
          <div class="form__group">
            <label class="form__label">Exclude Facility</label>
            <p-multiSelect
              class="form__multiSelect select-box"
              formControlName="excludeFacilitiesIds"
              [options]="facilities"
              defaultLabel="Select Facility"
              optionLabel="label"
              optionValue="value"
              [filter]="true"
              selectedItemsLabel="{0} facility(s) Selected"
            ></p-multiSelect>
          </div>
        </div>

        <div class="btns">
          <button type="submit" class="btn btn--primary">
            {{ loading ? 'Saving...' : 'Submit' }}
          </button>
          <button type="button" class="btn btn--secondary" (click)="onCancel()">Cancel</button>
        </div>
      </form>
    </div>
  </div>
</div>
<div class="loader-block" *ngIf="loading">
  <p-progressSpinner [style]="{ width: '50px', height: '50px' }" strokeWidth="8" fill="#ffffff" animationDuration=".8s"> </p-progressSpinner>
</div>
